"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.passwordValid = passwordValid;
exports.passwordMatch = passwordMatch;
var minChar = exports.minChar = 8;

function passwordValid(password) {
  return minChar <= password.length;
}

function passwordMatch(password, confirmPassword) {
  return password === confirmPassword;
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Password.js
// module id = 412
// module chunks = 0